var articleCards = document.querySelectorAll('.js-all-articles .cv-article-card');
var indexDisplayArticles = 4;
var moreToLoad = false;
var loadMoreBtn = document.querySelector('.js-all-articles + button:first-of-type');

articleCards.forEach(function (card, i) {
  if (i >= indexDisplayArticles) {
    card.style.display = 'none';
    moreToLoad = true;
  }
});

if (moreToLoad) {
  loadMoreBtn.classList.remove('tw-hidden');
}

loadMoreBtn.addEventListener('click', function () {
  indexDisplayArticles += 4;
  articleCards.forEach(function (card, i) {
    if (i <= indexDisplayArticles) {
      card.style.display = 'block';
    }
  });

  if (indexDisplayArticles >= articleCards.length) {
    loadMoreBtn.style.display = 'none';
  }
});
